var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from "react";
import classNames from "classnames";
import { DropDown } from "../DropDown";
import { Button } from "../Button";
import { Icon } from "../Icon";
import { getCleanLanguages, getNormalizedCurrentLanguage, getOrderedLanguages } from "./utils";
import { AVAILABLE_LANGUAGES, DEFAULT_LANGUAGE } from "./constants";
import "./language-selector.scss";
const defaultProps = {
    currentLanguage: DEFAULT_LANGUAGE,
    transparent: false,
    rotated: false,
    onChangeLanguage: () => { },
    isOpen: false,
    position: { vertical: "bottom", horizontal: "center" },
    transformOrigin: { vertical: "top", horizontal: "center" },
    triggerIcon: "globe-alt",
};
export const LanguageSelector = (_a) => {
    var { transparent, languages = ["en-GB", "it-IT"], dataTestId = "tecma-languageSelector", currentLanguage = DEFAULT_LANGUAGE, rotated = false, position, transformOrigin, onChangeLanguage = () => { }, isOpen, triggerIcon = "globe-alt", className } = _a, rest = __rest(_a, ["transparent", "languages", "dataTestId", "currentLanguage", "rotated", "position", "transformOrigin", "onChangeLanguage", "isOpen", "triggerIcon", "className"]);
    const openingDirection = () => {
        if ((position === null || position === void 0 ? void 0 : position.vertical) === "top" &&
            (transformOrigin === null || transformOrigin === void 0 ? void 0 : transformOrigin.vertical) === "bottom") {
            return "open-upwards";
        }
        return "open-downwards";
    };
    const classList = classNames("language-selector-dropdown", {
        rotated,
        [openingDirection()]: true,
    }, className);
    const triggerRef = useRef(null);
    const [isDropDownOpen, setIsDropDownOpen] = useState(isOpen || false);
    const triggerClassList = classNames("language-selector", { open: isDropDownOpen });
    const cleanLanguages = getCleanLanguages(languages);
    const orderedLanguages = getOrderedLanguages(cleanLanguages, rotated);
    const normalizedCurrentLanguage = getNormalizedCurrentLanguage(currentLanguage, orderedLanguages);
    const handleOnChangeLanguage = (language) => {
        setIsDropDownOpen(false);
        onChangeLanguage(language);
    };
    return (_jsx(DropDown, Object.assign({ className: classList, isOpen: isDropDownOpen, transformOrigin: rotated
            ? Object.assign(Object.assign({}, transformOrigin), { vertical: (transformOrigin === null || transformOrigin === void 0 ? void 0 : transformOrigin.vertical) === "bottom" ? "top" : "bottom" })
            : transformOrigin, trigger: _jsxs(Button, { className: triggerClassList, id: "language-selector-button", "aria-controls": isDropDownOpen ? "language-selector-menu" : undefined, "aria-haspopup": "true", "aria-expanded": isDropDownOpen ? "true" : undefined, onClick: () => setIsDropDownOpen(!isDropDownOpen), outlined: transparent, iconName: triggerIcon, "data-testid": `${dataTestId}-button`, ref: triggerRef, children: [AVAILABLE_LANGUAGES[normalizedCurrentLanguage].language, _jsx(Icon, { iconName: "chevron-down", className: `language-selector__chevron ${isDropDownOpen ? "open" : ""} ` })] }), "data-testid": `${dataTestId}-dropdown`, position: rotated
            ? Object.assign(Object.assign({}, position), { vertical: (position === null || position === void 0 ? void 0 : position.vertical) === "bottom" ? "top" : "bottom" })
            : position, onToggle: () => setIsDropDownOpen(!isDropDownOpen) }, rest, { children: orderedLanguages.map((language) => {
            const isSelected = normalizedCurrentLanguage === language;
            return (_jsxs(DropDown.Item, { className: `${isSelected ? "selected" : ""}`, onClick: () => handleOnChangeLanguage(language), children: [_jsxs("div", { className: "language-selector__wrapper", children: [_jsx("span", { className: "language-selector__wrapper__language", children: AVAILABLE_LANGUAGES[language].language }), _jsx("span", { className: "language-selector__wrapper__region", children: AVAILABLE_LANGUAGES[language].region })] }), _jsx(Icon, { size: "small", className: `language-selector__icon ${isSelected ? "selected" : ""}`, filled: true, iconName: "check-circle" })] }, language));
        }) })));
};
LanguageSelector.defaultProps = defaultProps;
export default LanguageSelector;
